import { jpBasePath } from "./_base";

export const jpPathForgotPW = jpBasePath.appendPathSegment("/forgot-pw");